import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';

export class InitializeServerWithExternalUserRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('initializeServerWithExternalUser', params);
  }
}
